import React, { useState } from "react";

function ImageViewer({ src, alt }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <img src={src} alt={alt} onClick={handleOpen} />
      {isOpen && (
        <div className="lightbox">
          <button className="close-button" onClick={handleClose}>
            &times;
          </button>
          <img src={src} alt={alt} />
          <p className="image-title">{alt}</p>
        </div>
      )}
    </div>
  );
}

export default ImageViewer;
